import styled from 'styled-components';

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-top: -15px;
`;
